<template>
  <vonap-window
    transition="dialog-scale-transition"
    v-model="scheduleModalVisible"
    title="Delivery Schedule"
    width="750px"
    height="440px"
    :modal="true"
    @close="close"
  >
    <v-layout row justify-center>
      <vonap-promised :promise="loadData">
        <v-card class="mx-auto">
          <v-card-text>
            <v-container grid-list-sm text-xs-left class="py-0 px-1">
              <v-layout wrap>
                <v-flex xs3>
                  <v-text-field
                    label="Transaction Number"
                    disabled
                    v-model="operationModel.dealCode"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    label="Original Amount"
                    v-model="foreignAmount"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    label="Currency"
                    v-model="operationModel.foreignCcy"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    label="Last Maturity"
                    v-model="maturityDate"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container class="py-0 px-1">
              <v-layout wrap>
                <v-flex d-flex xs12>
                  <div>
                    <page-toolbar>
                      <kendo-button icon="add" title="Add" v-if="!isReadOnly" @click="addRowClick">
                      </kendo-button>
                      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel">
                      </kendo-button>
                    </page-toolbar>
                    <kendo-grid
                      ref="deliveryScheduleGrid"
                      :data-source="this.dataSource"
                      height="200px"
                      :editable="editableSettings"
                      :filterable="false"
                      :sortable="true"
                      :scrollable="true"
                      :pageable="false"
                      :pageable-always-visible="false"
                      :columns="gridColumns"
                    >
                    </kendo-grid>
                  </div>
                </v-flex>
                <div class="col-sm-3 text-xs-right">
                  <label>Undelivered Amount:</label>
                </div>
                <div class="col-sm-9">
                  {{ leftToSettle }}
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </vonap-promised>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import params from '@/helpers/params'
import {datePickerEditor, numericEditor} from '@/helpers/kendo-editors'
import VonapWindow from '../../../components/VonapWindow'
import VonapPromised from '@/components/VonapPromised'

export default {
  name: 'ScheduleDeliveryForm',
  components: {
    PageToolbar,
    VonapWindow,
    VonapPromised,
  },
  props: {
    operationId: {type: [Number, String], default: null},
    isReadOnly: {type: Boolean, default: true},
    scheduleModalVisible: Boolean,
  },
  data() {
    return {
      operationModel: {},
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    addRowClick() {
      let grid = this.$refs.deliveryScheduleGrid.kendoWidget()
      grid.addRow()
    },
    exportToExcel() {
      const qs = params.fromObject({
        operationId: this.operationId,
        t: this.tokenString,
      })
      location.href = `/api/list/deal/exportDeliveryScheduleToExcel?${qs}`
    },
    reloadGrid() {
      const grid = this.$refs.deliveryScheduleGrid.kendoWidget()
      grid.dataSource.read()
    },
    async getDeliverySchedule() {
      const response = await axios.get('/api/list/deal/getDeliverySchedule', {
        params: {
          operationId: this.operationId,
          t: new Date().getTime(),
        },
      })

      if (response.status == 200) {
        let model = response.data
        this.operationModel = model
      }
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),

    isGuest() {
      return this.currentRole === 'Guest'
    },
    foreignAmount() {
      return kendo.toString(this.operationModel.foreignAmount, 'n2')
    },
    leftToSettle() {
      return kendo.toString(this.operationModel.leftToSettle, 'n2')
    },
    maturityDate() {
      return kendo.toString(kendo.parseDate(this.operationModel.maturityDate), 'yyyy-MM-dd')
    },
    editable: function() {
      return !this.isGuest
    },
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        transport: {
          read: {
            type: 'GET',
            dataType: 'json',
            url: '/api/list/deal/deliverySchedule',
            data: () => ({operationId: this.operationId, clientId: this.clientId}),
          },
          create: {
            type: 'POST',
            url: '/api/list/deal/deliverySchedule',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
            complete: () => {
              this.getDeliverySchedule()
              this.reloadGrid()
            },
          },
          update: {
            type: 'PUT',
            url: '/api/list/deal/deliverySchedule',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
            complete: () => {
              this.getDeliverySchedule()
              this.reloadGrid()
            },
          },
          destroy: {
            type: 'DELETE',
            url: '/api/list/deal/deliverySchedule',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
            complete: () => {
              this.getDeliverySchedule()
              this.reloadGrid()
            },
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'deliveryScheduleId',
            fields: {
              deliveryScheduleId: {type: 'number', defaultValue: 0, editable: false},
              operationId: {type: 'number', defaultValue: this.operationId, editable: false},
              sequence: {type: 'number', defaultValue: 0, editable: false},
              reference: {type: 'string', validation: {required: false}},
              amount: {type: 'number', validation: {required: true}},
              deliveryDate: {type: 'date', defaultValue: null, validation: {required: true}},
            },
          },
        },
      })
    },

    gridColumns: function() {
      let columns = [
        {command: 'edit', title: '&nbsp;', width: 58, hidden: !this.editable},
        {
          field: 'sequence',
          title: 'Deliv. #',
          width: 80,
          attributes: {style: 'text-align:center'},
        },
        {
          field: 'amount',
          title: 'Delivery Amount',
          width: 132,
          attributes: {style: 'text-align:right'},
          editor: (container, options) => {
            let maxValue = this.operationModel.leftToSettle + this.operationModel.amount
            return numericEditor({
              decimals: 2,
              format: '{0:n2}',
              min: 0,
              max: maxValue,
              spinners: false,
              step: 0,
            }).call(this, container, options)
          },
          format: '{0:n2}',
        },
        {
          field: 'deliveryDate',
          title: 'Delivery Date',
          width: 150,
          attributes: {style: 'text-align:right'},
          editor: (container, options) => {
            return datePickerEditor(
              {
                format: 'yyyy-MM-dd',
                min: this.operationModel.tradeDate,
                max: this.operationModel.maturityDate,
              },
              true,
            ).call(this, container, options)
          },
          format: '{0:yyyy-MM-dd}',
        },
        {field: 'reference', title: 'Reference', width: 180},
        {
          command: 'destroy',
          title: '&nbsp;',
          hidden: !this.editable,
        },
      ]
      return columns
    },

    editableSettings: function() {
      return {
        mode: 'inline',
        update: this.editable,
        destroy: this.editable,
        confirmation: false,
        createAt: 'bottom',
      }
    },
    loadData() {
      return this.getDeliverySchedule()
    },
  },
}
</script>
